/**
 * Boutique detail page: renders opening hours + Leaflet map for a single boutique.
 */
(function () {
  'use strict';

  const DAY_LABELS = {
    Monday: 'Montag', Tuesday: 'Dienstag', Wednesday: 'Mittwoch',
    Thursday: 'Donnerstag', Friday: 'Freitag', Saturday: 'Samstag', Sunday: 'Sonntag',
  };
  const DAY_ORDER = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }

  function renderHours() {
    const host = document.querySelector('[data-bd-hours]');
    if (!host) return;
    let hours;
    try {
      hours = JSON.parse(host.dataset.bdHours.replace(/&quot;/g, '"').replace(/&#39;/g, "'"));
    } catch (e) {
      return;
    }
    const rows = DAY_ORDER
      .filter((d) => hours[d])
      .map((d) => {
        const slots = hours[d];
        const text = Array.isArray(slots) && slots.length
          ? slots.map((s) => `${s.open_hour} bis ${s.close_hour}`).join(', ')
          : 'Geschlossen';
        const isClosed = !Array.isArray(slots) || slots.length === 0;
        return `<div class="bd__day">
          <span class="bd__day-name">${DAY_LABELS[d]}</span>
          <span class="bd__day-hours${isClosed ? ' is-closed' : ''}">${escapeHtml(text)}</span>
        </div>`;
      });
    host.innerHTML = rows.join('');
  }

  function renderMap() {
    if (typeof L === 'undefined') {
      setTimeout(renderMap, 50);
      return;
    }
    const mapEl = document.querySelector('[data-bd-map]');
    if (!mapEl) return;
    const lat = parseFloat(mapEl.dataset.lat);
    const lng = parseFloat(mapEl.dataset.lng);
    const name = mapEl.dataset.name || '';
    if (isNaN(lat) || isNaN(lng)) return;

    const map = L.map(mapEl, { attributionControl: false, scrollWheelZoom: false })
      .setView([lat, lng], 16);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(map);

    const pin = L.divIcon({
      className: 'bd-pin',
      html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 32" width="36" height="48"><path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 20 12 20s12-11 12-20C24 5.4 18.6 0 12 0z" fill="#556b2a"/><circle cx="12" cy="12" r="4.5" fill="#ffffff"/></svg>',
      iconSize: [36, 48],
      iconAnchor: [18, 48],
      popupAnchor: [0, -44],
    });
    L.marker([lat, lng], { icon: pin }).addTo(map).bindPopup(`<strong>${escapeHtml(name)}</strong>`).openPopup();
  }

  function init() {
    renderHours();
    renderMap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
